import * as React from "react";
import { useState, useEffect, useContext, useMemo } from "react";
import { BrowserRouter as Router, Link, useLocation } from "react-router-dom";
import {
  DataGrid,
  GridColumns,
  GridRowId,
  GridRowsProp,
  GridRowParams,
  GridValueGetterParams,
  GridValueSetterParams,
  GridCellValue,
  GridRenderCellParams,
  GridSelectionModel,
} from "@mui/x-data-grid";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import { confirmAlert } from "react-confirm-alert";

/* LOCALIZAÇÃO */

import { format } from "date-fns";
import { pt } from "date-fns/locale";

/* ICONES */
import FileUploadIcon from "@mui/icons-material/FileUpload";
import ApprovalIcon from "@mui/icons-material/Approval";
import SaveIcon from "@mui/icons-material/Save";
import ReplayIcon from "@mui/icons-material/Replay";
import IconButton from "@mui/material/IconButton";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import Download from "@mui/icons-material/Download";
import Grid from "@mui/material/Grid";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import moment from "moment";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";

/* Dialog */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

/* DADOS */
import ForecastDiarizadoDataSet from "../../components/data/ForecastDiarizadoDataSet";
//import ForecastDataSetPortal from "../../components/data/ForecastDataSetPortal";

/* CLASSES */
import ForecastDiarizado from "../../components/classes/ForecastDiarizado";
import Contrato from "../../components/classes/Contrato";
import UnidadeArmazenamento from "../../components/classes/UnidadeArmazenamento";
import UnidadeArmazenamentoDataset from "../../components/data/UnidadeArmazenamentoDataSet";

/* COMPONENTES CUSTOMIZADOS */
import ForecastTopo from "./topo";
import LancamentoDiarioPassoAPasso from "./lancamentoDiarioPassos";
import FileUpload from "../../components/common/FileUpload";
import PageHelper from "../../helper/pageHelper";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers";
import StepLogsHistoryDetalhe from "../../components/common/StepLogsHistoryModal/StepLogsHistoryDetalhe";

/* D O W N L O A D */
import { Alert, Modal, Snackbar, TextField } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { Send } from "@mui/icons-material";
import { ptBR } from "date-fns/locale";
import PropriedadeParceiro from "../../components/classes/PropriedadeParceiro";
import SkuDescricao from "../../components/common/SkuDescricao";
import { UserContext } from "../../App";
import DownloadCSVModal from "../../components/common/DownloadCSVModal/DownloadCSVModal";
import Utils from "../../helper/utils";
import CSVDetalhesModal from "../../components/common/CSVDetalhesModal/CSVDetalhesModal";
import AutocompleteJustificativaCommon from "../../components/common/AutocompleteJustificativaCommon";

import styles from "./detail.module.css";
import AutocompleteSKU from "../../components/common/AutocompleteSku";

import { useTranslation } from "react-i18next";

enum FILTER_NAMES {
  valueDTinicio = "dataInicio",
  valueDTfim = "dataFim",
  codigoSku = "skus",
  descricaoSku = "descricaoSku",
  quantidade = "quantidade",
}

interface IFilter {
  [FILTER_NAMES.valueDTinicio]?: Date | null;
  [FILTER_NAMES.valueDTfim]?: Date | null;
  [FILTER_NAMES.codigoSku]?: string[];
  [FILTER_NAMES.descricaoSku]?: string;
  [FILTER_NAMES.quantidade]?: string;
}

export default function LancamentoDiarioPage() {
  const { t } = useTranslation();

  const user: any = useContext(UserContext);
  const increase = 4;
  const [loading, setLoading] = useState(true);
  const [valorAnterior, SetValorAnterior] = useState(0);

  /* PAGINAÇÃO */
  const [pageSize, setPageSize] = useState(50);
  const [forecasts, setForecasts] = useState<ForecastDiarizado[]>([]);
  const [forecastsTemp, setForecastsTemp] = useState<ForecastDiarizado[]>([]);
  const [historyId, setHistoryId] = useState(0);
  const dataForecastDiarizado: ForecastDiarizadoDataSet =
    new ForecastDiarizadoDataSet();
  //const dataForecastPortal: ForecastDataSetPortal = new ForecastDataSetPortal();
  const dataSKU: UnidadeArmazenamentoDataset =
    new UnidadeArmazenamentoDataset();
  const codigoFornecedorSap: number = Number(
    localStorage.getItem("CodigoFornecedorSAPSelecionado")
  );

  const [openSnackBar, setOpenSnackBar] = useState<boolean>(false);
  const [csvFoiEnviado, setCsvFoiEnviado] = useState<{
    wasUpdated: boolean;
    isSuccess: boolean;
    details: string;
  }>({ wasUpdated: false, isSuccess: false, details: "" });
  const [openDownloadCSVModal, setOpenDownloadCSVModal] =
    useState<boolean>(false);
  const [openCSVDetalhesModal, setOpenCSVDetalhesModal] =
    useState<boolean>(false);
  const [idsSelecionados, setIdsSelecionados] = useState<GridRowId[]>([]);
  const hasIdSelecionado: boolean = useMemo(
    () => idsSelecionados && idsSelecionados.length > 0,
    [idsSelecionados]
  );

  /* G R I D */
  interface Data {
    id: number;
    codigoFornecedorSap: number;
    numeroContrato: string;
    idSku: string;
    descricao: string;
    centro: string;
    anoMesRef: string;
    dia: string;
    quantidade: number;
    quantidadeProposta: number;
    aderencia: number;
    justificativa: string;
    recupera: boolean;
    quando: Date;
    siglaSku: string;
  }

  interface Download {
    idSku: string;
    centro: string;
    dia: string;
    quantidade: string;
    justificativa: string;
  }

  const [rows, setRows] = useState<Data[]>([]);
  const [openFilter, setOpenFilter] = useState(false);

  const handleClickOpenFilter = () => {
    setFilter({} as IFilter);
    setOpenFilter(true);
  };

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  /* FILTER */
  const [filter, setFilter] = useState({} as IFilter);
  /** @deprecated */
  const [valueDTinicio, setValueDTinicio] = useState<Date | null>(null);
  /** @deprecated */
  const [valueDTfim, setValueDTfim] = useState<Date | null>(null);

  const [filtra, setFiltra] = useState(false);

  const handleChangeFilter = React.useCallback((event) => {
    setFilter((prev) => ({ ...prev, [event.target.name]: event.target.value }));
  }, []);

  function useQuery() {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();
  let _step: number =
    query.get("step")?.valueOf() === undefined
      ? 1
      : Number(query.get("step")?.valueOf());
  const step = _step > 0 && _step <= 2 ? _step : 3;

  const titleAprova: string = t(
    "pages.dailyProductionRelease.text.approveItemData"
  );

  const Input = styled("input")({
    display: "none",
  });

  var _contrato: Contrato =
    localStorage.getItem("ContratoSelecionado") === null ||
    localStorage.getItem("ContratoSelecionado") === undefined
      ? console.log("Contrato não selecionado")
      : JSON.parse(String(localStorage.getItem("ContratoSelecionado")));

  const numeroContrato: string = String(
    _contrato !== null && _contrato !== undefined
      ? _contrato.numeroContrato
      : "(undefined)"
  );

  const parceiroSelecionadoCache = String(
    localStorage.getItem("PropriedadeParceiroCache")
  );
  const fatorAderencia: number = useMemo(() => {
    let fator: number = 10;
    if (parceiroSelecionadoCache && parceiroSelecionadoCache !== "undefined") {
      const parceiroSelecionado: PropriedadeParceiro[] = JSON.parse(
        parceiroSelecionadoCache
      );
      const fatorTemp = parceiroSelecionado
        ? parceiroSelecionado.find((f) => f.chave === "DESVIO DE ADERENCIA")
            ?.valor
        : 10;
      if (fatorTemp) {
        fator = Number(fatorTemp);
      }
    }
    return fator;
  }, [parceiroSelecionadoCache]);

  useEffect(() => {
    refreshAllData();
  }, []);

  useEffect(() => {
    refreshAllData();
    Utils.setDocumentTitle(
      t("pages.dailyProductionRelease.titlePage"),
      step === 2
        ? `(${t("pages.dailyProductionRelease.text.approvalOfDeviations")})`
        : ""
    );
  }, [step]);

  useEffect(() => {
    setOpen(false);
    if (csvFoiEnviado.wasUpdated) {
      setOpenSnackBar(true);
      if (csvFoiEnviado.isSuccess) {
        setLoading(true);
        dataForecastDiarizado
          .ListarAtivosPorPasso(
            codigoFornecedorSap,
            numeroContrato,
            step + increase
          )
          .then((data) => {
            if (data) {
              data.forEach((forecast) => {
                if (!forecast.quando) {
                  forecast.quando = new Date();
                }
              });
              setForecasts(data);
              preencherGrid(data);
            }
            setLoading(false);
          });
      }
    }
  }, [csvFoiEnviado]);

  const handleIntegracaoPlanoBase = () => {
    let ids: string[] = String(
      localStorage.getItem("idsLancamentoDiario")
    ).split(",");
    MensagemBackgoundProcess(ids.length);
    ids.map((id: string) => {
      let reg: ForecastDiarizado = forecasts.filter(
        (f) => f.id === Number(id)
      )[0];
      //dataForecastPortal.Integra(reg);
    });
    Mensagem(
      t("common.warning"),
      ids.length > 1
        ? `${t("pages.dailyProductionRelease.text.thePlural")}` +
            ids.length +
            `${t(
              "pages.dailyProductionRelease.text.itemsSuccessfullyIntegrated"
            )}`
        : `${t(
            "pages.dailyProductionRelease.text.itemSuccessfullyIntegrated"
          )} \n\r`
    );
  };

  const handleClickSave = () => {
    let ids: string[] = String(
      localStorage.getItem("idsLancamentoDiario")
    ).split(",");
    let upgradableForecastDiario: ForecastDiarizado[] = [];
    MensagemBackgoundProcess(ids.length);
    ids.forEach((id: string) => {
      let reg: ForecastDiarizado | undefined = forecasts.find(
        (f) => f.id === Number(id)
      );
      if (reg) {
        reg.aprovadoParceiro = false;
        upgradableForecastDiario.push(reg);
      }
    });
    dataForecastDiarizado
      .AtualizarColecao(upgradableForecastDiario)
      .then((result) => {
        if (result) {
          Mensagem(
            t("common.warning"),
            ids.length > 1
              ? `${t("pages.dailyProductionRelease.text.thePlural")}` +
                  ids.length +
                  `${t(
                    "pages.dailyProductionRelease.text.itemsSuccessfullyUpdated"
                  )}`
              : `${t(
                  "pages.dailyProductionRelease.text.itemSuccessfullyUpdated"
                )} \n\r`
          );
        } else {
          Mensagem(
            t("common.error"),
            ids.length > 1
              ? `${t("pages.dailyProductionRelease.text.thePlural")}` +
                  ids.length +
                  `${t(
                    "pages.dailyProductionRelease.text.itemsSuccessfullyFail"
                  )}`
              : `${t(
                  "pages.dailyProductionRelease.text.itemSuccessfullyFail"
                )} \n\r`
          );
        }
      });
  };

  const handleConfimation = (titulo: string, mensagem: string) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [
        {
          label: t("common.yes"),
          onClick: async () => {
            await setOpen(false);
            handleClickAprove();
          },
        },
        {
          label: t("common.no"),
          onClick: () => {
            setOpen(false);
          },
        },
      ],
    });
  };

  const handleClickAprove = () => {
    let ids: string[] = String(
      localStorage.getItem("idsLancamentoDiario")
    ).split(",");
    let upgradableForecastDiario: ForecastDiarizado[] = [];
    MensagemBackgoundProcess(ids.length);
    for (const id of ids) {
      let reg: ForecastDiarizado | undefined = forecasts.find(
        (f) => f.id === Number(id)
      );
      if (reg) {
        const valorAderencia: number = fatorAderencia
          ? 100 - fatorAderencia
          : 90;
        const aderenciaReg = calcularAderencia(reg);
        if (
          step === 1 &&
          aderenciaReg < valorAderencia &&
          (!reg.justificativaLancamento || !reg.quando)
        ) {
          upgradableForecastDiario = [];
          Mensagem(
            t("common.warning"),
            t("pages.dailyProductionRelease.text.adhesionLessThan", {
              valorAderencia,
            }),
            false
          );
          break;
        } else {
          if (step === 2) {
            reg.aprovadoBRF = true;
            reg.aprovadoParceiro = true;
          } else {
            reg.aprovadoBRF = false;
            reg.aprovadoParceiro = true;
          }
          //   reg.step = step + 3
          upgradableForecastDiario.push(reg);
        }
      }
    }
    if (upgradableForecastDiario?.length > 0) {
      atualizarColecao(true, upgradableForecastDiario, ids);
    }
  };

  const handleClickNotAprove = () => {
    let ids: string[] = String(
      localStorage.getItem("idsLancamentoDiario")
    ).split(",");
    let upgradableForecastDiario: ForecastDiarizado[] = [];
    MensagemBackgoundProcess(ids.length);
    ids.forEach((id: string) => {
      let reg: ForecastDiarizado | undefined = forecasts.find(
        (f) => f.id === Number(id)
      );
      if (reg) {
        reg.aprovadoBRF = false;
        reg.aprovadoParceiro = false;
        upgradableForecastDiario.push(reg);
      }
    });

    atualizarColecao(false, upgradableForecastDiario, ids);
  };

  function refreshAllData() {
    const fetchData = async () => {
      const data = await dataForecastDiarizado.ListarAtivosPorPasso(
        codigoFornecedorSap,
        numeroContrato,
        step + increase
      );
      data.forEach((forecast) => {
        if (!forecast.quando) {
          forecast.quando = new Date();
        }
      });
      setForecasts(data);
      setForecastsTemp(data);
      preencherGrid(data);
      setLoading(false);
    };
    fetchData().catch(console.error);
  }

  function atualizarColecao(
    approve: boolean,
    upgradableForecastDiario: ForecastDiarizado[],
    ids: string[]
  ) {
    setLoading(true);
    var complemento: string =
      step === 2
        ? t("pages.dailyProductionRelease.text.rememberSapIntegration")
        : "";
    dataForecastDiarizado
      .AtualizarColecao(upgradableForecastDiario)
      .then((result) => {
        atualizaListaForecast().then(() => {
          setLoading(false);
          if (result) {
            if (approve) {
              Mensagem(
                t("common.warning"),
                ids.length > 1
                  ? `${t("pages.dailyProductionRelease.text.thePlural")}` +
                      ids.length +
                      `${t(
                        "pages.dailyProductionRelease.text.itemsApprovedForNextStep"
                      )}` +
                      complemento
                  : `${t(
                      "pages.dailyProductionRelease.text.itemApprovedForNextStep"
                    )}` + complemento,
                false
              );
            } else {
              Mensagem(
                t("common.warning"),
                ids.length > 1
                  ? `${t("pages.dailyProductionRelease.text.thePlural")}` +
                      ids.length +
                      `${t(
                        "pages.dailyProductionRelease.text.itemsDontApprovedForNextStep"
                      )}`
                  : `${t(
                      "pages.dailyProductionRelease.text.itemDontApprovedForNextStep"
                    )}`,
                false
              );
            }
          } else {
            if (approve) {
              Mensagem(
                t("common.error"),
                ids.length > 1
                  ? `${t("pages.dailyProductionRelease.text.thePlural")}` +
                      ids.length +
                      `${t(
                        "pages.dailyProductionRelease.text.itemsNotProcessedProperly"
                      )}` +
                      complemento
                  : `${t(
                      "pages.dailyProductionRelease.text.itemNotProcessedProperly"
                    )}` + complemento,
                false
              );
            } else {
              Mensagem(
                t("common.error"),
                ids.length > 1
                  ? `${t("pages.dailyProductionRelease.text.thePlural")}` +
                      ids.length +
                      `${t(
                        "pages.dailyProductionRelease.text.itemsNotProcessedProperly"
                      )}`
                  : `${t(
                      "pages.dailyProductionRelease.text.itemNotProcessedProperly"
                    )}`,
                false
              );
            }
          }
        });
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  }

  async function atualizaListaForecast() {
    refreshAllData();
  }

  function dateFormat(date: Date): string {
    return date.toLocaleDateString("pt-BR");
  }

  const handlerDataSolicitadaChange = (params: any, value: Date) => {
    if (!value) return;

    const forecastFound = forecasts.find((f) => f.id === params.id);
    if (forecastFound) {
      forecastFound.quando = value;
    }
    setForecasts(forecasts);
    preencherGrid(forecasts);
  };

  const columns: GridColumns = MontaColunas();

  function MontaColunas(): GridColumns {
    let cols: GridColumns = [];
    if (step === 1) {
      cols = [
        {
          field: "id",
          headerName: "#",
          width: 80,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "hist",
          headerName: t("common.historic"),
          width: 80,
          align: "center",
          headerAlign: "center",
          renderCell: (params) => (
            <Tooltip title={t("common.viewHistoric")}>
              <span>
                <IconButton onClick={() => setHistoryId(params.row.id)}>
                  <HistoryToggleOffIcon />
                </IconButton>
              </span>
            </Tooltip>
          ),
        },
        {
          field: "idSku",
          headerName: t("common.skuCode"),
          type: "number",
          width: 110,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "siglaSku",
          headerName: t("common.acronym"),
          type: "string",
          width: 190,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "descricao",
          headerName: t("common.skuDescription.label"),
          type: "string",
          width: 300,
          editable: false,
          align: "left",
          headerAlign: "center",
          renderCell: (params) => <SkuDescricao value={params.value} />,
        },
        {
          field: "centro",
          headerName: t("common.center"),
          type: "number",
          width: 110,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "anoMesRef",
          headerName: t("common.monthYearRef"),
          type: "string",
          width: 110,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "dia",
          headerName: t("common.date"),
          type: "string",
          width: 110,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "quantidade",
          headerName: t("common.quantity"),
          type: "number",
          width: 150,
          editable: false,
          align: "right",
          headerAlign: "center",
          valueFormatter: (params) => round3(params.value) + " Kg",
        },
        {
          field: "quantidadeProposta",
          headerName: t("common.producedQuantity"),
          type: "number",
          width: 170,
          editable: !(user.isSuporte || user.isPlanejamentoBRF),
          align: "right",
          headerAlign: "center",
          renderCell: (gridItem) => (
            <p>{round3(gridItem.row.quantidadeProposta)} Kg</p>
          ),
          cellClassName: (gridItem: any) => {
            let forecastAtual = forecastsTemp.find(
              (forecast) => forecast.id == gridItem.id
            );
            if (forecastAtual) {
              return forecastAtual.quantidadeProposta !=
                gridItem.row.quantidadeProposta
                ? "celulaAlterada"
                : "";
            }
            return "";
          },
        },
        {
          field: "aderencia",
          headerName: t("common.grip"),
          type: "number",
          width: 120,
          editable: false,
          align: "right",
          headerAlign: "center",
          valueFormatter: (params) => round3(params.value) + "%",
        },
        {
          field: "justificativa",
          headerName: t("common.justify"),
          width: 200,
          editable: !(user.isSuporte || user.isPlanejamentoBRF),
          align: "left",
          headerAlign: "center",
          type: "string",
          renderCell: (params) => <SkuDescricao value={params.value} />,
          renderEditCell: (gridItem) => {
            return (
              <AutocompleteJustificativaCommon
                gridItem={gridItem}
                tipo={"Lancamento"}
              />
            );
          },
          cellClassName: (gridItem: any) => {
            let forecastAtual = forecastsTemp.find(
              (forecast) => forecast.id == gridItem.id
            );
            if (forecastAtual) {
              return forecastAtual.justificativaLancamento !=
                gridItem.formattedValue
                ? "celulaAlterada"
                : "";
            }
            return "";
          },
        },
        {
          field: "recupera",
          headerName: t("pages.dailyProductionRelease.text.payWithinMonth"),
          width: 100,
          editable: !(user.isSuporte || user.isPlanejamentoBRF),
          align: "center",
          headerAlign: "center",
          type: "boolean",
          cellClassName: (gridItem: any) => {
            let forecastAtual = forecastsTemp.find(
              (forecast) => forecast.id == gridItem.id
            );
            if (forecastAtual) {
              const valorBoolean: boolean =
                gridItem.formattedValue == t("common.yes");
              return forecastAtual.recupera != valorBoolean
                ? "celulaAlterada"
                : "";
            }
            return "";
          },
        },
        {
          field: "quando",
          headerName: t("pages.dailyProductionRelease.text.when"),
          width: 200,
          editable: false,
          align: "left",
          headerAlign: "center",
          cellClassName: (gridItem: any) => {
            let forecastAtual = forecastsTemp.find(
              (forecast) => forecast.id == gridItem.id
            );
            if (forecastAtual) {
              try {
                return new Date(forecastAtual.quando).toISOString() !=
                  gridItem.formattedValue.toISOString()
                  ? "celulaAlterada"
                  : "";
              } catch (e) {
                return "";
              }
            }
            return "";
          },
          renderCell: (params: GridRenderCellParams) => {
            return (
              <>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    disabled={user.isSuporte || user.isPlanejamentoBRF}
                    label={t("pages.dailyProductionRelease.text.for")}
                    value={params.value}
                    onChange={(newValue: any) => {
                      handlerDataSolicitadaChange(params, newValue);
                    }}
                    inputFormat="dd/MM/yyyy"
                    renderInput={(params: any) => (
                      <TextField {...params} size="small" />
                    )}
                  />
                </LocalizationProvider>
              </>
            );
          },
        },
      ];
    } else {
      cols = [
        {
          field: "id",
          headerName: "#",
          width: 80,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "hist",
          headerName: t("common.historic"),
          width: 80,
          align: "center",
          headerAlign: "center",
          renderCell: (params) => (
            <Tooltip title={t("common.viewHistoric")}>
              <span>
                <IconButton onClick={() => setHistoryId(params.row.id)}>
                  <HistoryToggleOffIcon />
                </IconButton>
              </span>
            </Tooltip>
          ),
        },
        {
          field: "idSku",
          headerName: t("common.skuCode"),
          type: "number",
          width: 110,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "siglaSku",
          headerName: t("common.acronym"),
          type: "string",
          width: 190,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "descricao",
          headerName: t("common.skuDescription.label"),
          type: "string",
          width: 300,
          editable: false,
          align: "left",
          headerAlign: "center",
          renderCell: (params) => <SkuDescricao value={params.value} />,
        },
        {
          field: "centro",
          headerName: t("common.center"),
          type: "number",
          width: 110,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "anoMesRef",
          headerName: t("common.monthYearRef"),
          type: "string",
          width: 110,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "dia",
          headerName: t("common.date"),
          type: "string",
          width: 110,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "quantidade",
          headerName: t("common.quantity"),
          type: "number",
          width: 150,
          editable: false,
          align: "right",
          headerAlign: "center",
          valueFormatter: (params) => round3(params.value) + " Kg",
        },
        {
          field: "quantidadeProposta",
          headerName: t("common.producedQuantity"),
          type: "number",
          width: 170,
          editable: false,
          align: "right",
          headerAlign: "center",
          valueFormatter: (params) => round3(params.value) + " Kg",
        },
        {
          field: "aderencia",
          headerName: t("common.grip"),
          type: "number",
          width: 120,
          editable: false,
          align: "right",
          headerAlign: "center",
          valueFormatter: (params) => round3(params.value) + "%",
        },
        {
          field: "justificativa",
          headerName: t("common.justify"),
          width: 200,
          editable: false,
          align: "left",
          headerAlign: "center",
          renderCell: (params) => <SkuDescricao value={params.value} />,
        },
      ];
    }
    return cols;
  }

  const GetSKUName = (_idSKU: number): string => {
    let nome: string = "";
    try {
      let objeto: UnidadeArmazenamento = dataSKU
        .ListarFromCache()
        .filter((f) => f.idSKU === _idSKU)[0];
      nome = objeto.descricao;
    } catch (error) {
      console.log(_idSKU + "- Não Encontrou!");
    }
    return nome;
  };

  function round3(value: number) {
    return value ? stripZeros(value.toFixed(3)) : 0;
  }

  function stripZeros(str: string) {
    return parseFloat(str.replace(",", ".")).toString().replace(".", ",");
  }

  function createData(
    id: number,
    codigoFornecedorSap: number,
    numeroContrato: string,
    idSku: string,
    descricao: string,
    centro: string,
    anoMesRef: string,
    dia: string,
    quantidade: number,
    quantidadeProposta: number,
    aderencia: number,
    justificativa: string,
    recupera: boolean,
    quando: Date,
    siglaSku: string
  ): Data {
    return {
      id,
      codigoFornecedorSap,
      numeroContrato,
      idSku,
      descricao,
      centro,
      anoMesRef,
      dia,
      quantidade,
      quantidadeProposta,
      aderencia,
      justificativa,
      recupera,
      quando,
      siglaSku,
    };
  }

  function createDownload(
    idSku: string,
    centro: string,
    dia: string,
    quantidade: string,
    justificativa: string
  ): Download {
    return {
      idSku,
      centro,
      dia,
      quantidade,
      justificativa,
    };
  }
  function preencherGrid(_data: ForecastDiarizado[]) {
    setRows(
      _data.map((item: ForecastDiarizado) => {
        return createData(
          Number(item.id),
          Number(item.codigoFornecedorSap),
          String(item.numeroContrato),
          String(item.idSku),
          GetSKUName(Number(item.idSku)),
          String(item.centro),
          String(
            item.anoMesRef.toString().substring(6, 4) +
              "/" +
              item.anoMesRef.toString().substring(0, 4)
          ),
          String(
            item.dia.toString().substring(10, 8) +
              "/" +
              item.dia.toString().substring(7, 5) +
              "/" +
              item.dia.toString().substring(0, 4)
          ),
          Number(item.quantidade),
          Number(item.quantidadeProposta),
          calcularAderencia(item),
          String(item.justificativaLancamento),
          item.recupera,
          item.quando ? new Date(item.quando) : new Date(),
          item.siglaSku
        );
      })
    );
  }

  const Mensagem = (
    titulo: string,
    mensagem: string,
    refresh: boolean = true
  ) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [
        {
          label: t("common.ok"),
          onClick: () => {
            setOpen(false);
            if (refresh) {
              PageHelper.refreshPage();
            }
          },
        },
      ],
    });
  };

  function calcularAderencia(item: ForecastDiarizado) {
    let aderencia = 0;

    if (item.quantidade == 0 && item.quantidadeProposta == 0) return 100;

    if (item.quantidadeProposta && item.quantidade && item.quantidade > 0) {
      if (item.quantidadeProposta <= item.quantidade) {
        aderencia = item.quantidadeProposta / item.quantidade;
      } else {
        aderencia = 2 - item.quantidadeProposta / item.quantidade;
      }
    }
    if (step === 2 && aderencia * 100 < 100 - fatorAderencia) {
      return 100;
    }
    return aderencia > 0 ? aderencia * 100 : 0;
  }

  function MensagemBackgoundProcess(records: number) {
    <CircularProgress />;
  }

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpenDownloadCSV = () => {
    setOpenDownloadCSVModal(true);
  };

  function handleCloseDownloadCSVModal() {
    setOpenDownloadCSVModal(false);
  }

  function handleClickOpenCSVDetalhesModal() {
    setOpenCSVDetalhesModal(true);
  }

  function handleCloseCSVDetalhesModal() {
    setOpenCSVDetalhesModal(false);
  }

  const handleCloseSnackBar = () => {
    setOpenSnackBar(false);
  };

  function handleSelectionChange(ids: any) {
    setIdsSelecionados(ids);
    if (ids !== null && ids !== undefined && ids.length > 0) {
      localStorage.setItem("idsLancamentoDiario", ids);
    } else {
      localStorage.removeItem("idsLancamentoDiario");
    }
  }

  function FileUploadPage() {
    return (
      <div>
        <FileUpload
          {...{
            endpoint:
              "Forecast/Diarizado/ProcessarPlanilha/Parceiro/" +
              codigoFornecedorSap +
              "/Contrato/" +
              numeroContrato +
              "/Passo/" +
              Number(step + increase),
            setCsvFoiEnviado: setCsvFoiEnviado,
          }}
        />
      </div>
    );
  }

  const handleCellEdtStart = (params: any) => {
    SetValorAnterior(params.row.quantidadeProposta);
    // console.log(JSON.stringify(params));
  };

  const handleRowEditCommit = (params: any) => {
    // console.log(JSON.stringify(params));
    if (
      params.field === "quantidadeProposta" ||
      params.field === "quantidade" ||
      params.field === "justificativa" ||
      params.field === "recupera"
    ) {
      const index = forecasts.findIndex((f) => f.id === params.id);
      if (params.field === "quantidadeProposta" && Number(params.value) < 0) {
        if (Number(params.value) < 0) {
          alert(
            t("pages.dailyProductionRelease.text.negativeValuesNotAllowed")
          );
          const updatedForecast = {
            ...forecasts[index],
            quantidadeProposta: valorAnterior,
          };
          if (updatedForecast !== undefined) {
            const tempRows = [
              ...forecasts.slice(0, index),
              updatedForecast,
              ...forecasts.slice(index + 1),
            ];
            setForecasts(tempRows);
            preencherGrid(tempRows);
          }
        }
      } else {
        const row = forecasts[index] as any;
        if (params.field === "justificativa") {
          if (
            "justificativaLancamento" in row &&
            row["justificativaLancamento"] !== params.value
          ) {
            const tempRows = [...forecasts] as any;
            tempRows[index]["justificativaLancamento"] = params.value;
            setForecasts(tempRows);
            preencherGrid(tempRows);
          }
        } else {
          if (params.field in row && row[params.field] !== params.value) {
            const tempRows = [...forecasts] as any;
            tempRows[index][params.field] = params.value;
            setForecasts(tempRows);
            preencherGrid(tempRows);
          }
        }
      }
    }
    // handleFilter();
  };

  const handleClickFilter = () => {
    if (filtra) {
      preencherGrid(forecasts);
    } else {
      handleClickOpenFilter();
    }
    setFiltra(!filtra);
  };

  const handleFilter = async () => {
    const requestData = {
      numeroContrato: String(numeroContrato),
      ...filter,
      [FILTER_NAMES.valueDTinicio]: filter[FILTER_NAMES.valueDTinicio]
        ? moment(filter[FILTER_NAMES.valueDTinicio]).format("YYYY-MM-DD")
        : null,
      [FILTER_NAMES.valueDTfim]: filter[FILTER_NAMES.valueDTfim]
        ? moment(filter[FILTER_NAMES.valueDTfim]).format("YYYY-MM-DD")
        : null,
      [FILTER_NAMES.codigoSku]:
        (filter[FILTER_NAMES.codigoSku] || []).length > 0
          ? filter[FILTER_NAMES.codigoSku]
              ?.map((item) => item.split(" - ")[0])
              .join(",")
          : null,
    };

    const filtered: ForecastDiarizado[] =
      await dataForecastDiarizado.RecuperarPorFiltros(
        requestData,
        codigoFornecedorSap,
        _step + increase
      );

    setForecasts(filtered);

    if (filtered.length > 0) {
      preencherGrid(filtered);
    } else {
      preencherGrid([]);
    }

    setOpenFilter(false);
  };

  function handleClickEstornarLancamento() {
    const forecastsSelecionados: ForecastDiarizado[] = forecasts.filter((f) =>
      idsSelecionados.includes(f.id)
    );
    if (forecastsSelecionados && forecastsSelecionados.length > 0) {
      dataForecastDiarizado.Estornar(forecastsSelecionados).then((result) => {
        if (result) {
          Mensagem(
            t("common.warning"),
            `${t("pages.dailyProductionRelease.text.thePlural")}${t(
              "pages.dailyProductionRelease.text.itemsSuccessfullyUpdated"
            )} \n\r`
          );
        } else {
          Mensagem(
            t("common.error"),
            `${t("pages.dailyProductionRelease.text.thePlural")}${t(
              "pages.dailyProductionRelease.text.itemsSuccessfullyFail"
            )} \n\r`
          );
        }
      });
    }
  }

  return (
    <div className={`container ${styles.container}`}>
      <ForecastTopo
        {...{
          data:
            step === 1
              ? ""
              : step === 2
              ? `(${t(
                  "pages.dailyProductionRelease.text.approvalOfDeviations"
                )})`
              : "",
        }}
      />
      <div className="containerToolbar">
        {filtra === false ? (
          <Tooltip
            title={t(
              "pages.dailyProductionRelease.text.enablesFilteringByDate"
            )}
          >
            <span>
              <IconButton
                onClick={handleClickFilter}
                disabled={!(rows.length >= 0) || loading}
              >
                <FilterAltIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : (
          <Tooltip title={t("pages.dailyProductionRelease.text.disableFilter")}>
            <span>
              <IconButton
                onClick={handleClickFilter}
                disabled={!filtra || loading}
              >
                <FilterAltOffIcon />
              </IconButton>
            </span>
          </Tooltip>
        )}
        {step === 2 && (user.isPlanejamentoBRF || user.isRoot) ? (
          <Tooltip
            title={t("pages.dailyProductionRelease.text.moveSelectedLine")}
          >
            <span>
              <IconButton
                onClick={handleClickEstornarLancamento}
                disabled={!hasIdSelecionado || loading}
              >
                <ReplayIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}
        {step === 1 ? (
          <Tooltip
            title={t(
              "pages.dailyProductionRelease.text.saveChangesWithoutAdvance"
            )}
          >
            <span>
              <IconButton
                onClick={handleClickSave}
                disabled={
                  !hasIdSelecionado ||
                  loading ||
                  user.isSuporte ||
                  (step === 1 && user.isPlanejamentoBRF)
                }
              >
                <SaveIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}{" "}
        {(step == 1 && user.isPlanejamento) ||
        user.isPlanejamentoBRF ||
        user.isRoot ? (
          <Tooltip title={titleAprova}>
            <span>
              <IconButton
                onClick={() =>
                  handleConfimation(
                    t("common.warning"),
                    t("pages.dailyProductionRelease.text.wishContinue")
                  )
                }
                disabled={
                  !hasIdSelecionado ||
                  loading ||
                  user.isSuporte ||
                  (step === 1 && user.isPlanejamentoBRF)
                }
              >
                <Send />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}{" "}
        {step === -2 ? (
          <Tooltip
            title={t(
              "pages.dailyProductionRelease.text.reproveDataAndBackStep"
            )}
          >
            <span>
              <IconButton
                onClick={handleClickNotAprove}
                disabled={!hasIdSelecionado || loading || user.isSuporte}
              >
                <NotInterestedIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}{" "}
        {step < 2 ? (
          <Tooltip title={t("pages.dailyProductionRelease.text.uploadCsvFile")}>
            <span>
              <IconButton
                onClick={handleClickOpen}
                disabled={
                  loading ||
                  user.isSuporte ||
                  (step === 1 && user.isPlanejamentoBRF)
                }
              >
                <FileUploadIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}{" "}
        {step <= 2 ? (
          // <CSVLink
          //   filename="lancamentoDiario.csv"
          //   data={forecasts.map((item) => {
          //     return createDownload(
          //       item.idSku,
          //       item.centro,
          //       String(
          //         item.dia.toString().substring(10, 8) +
          //           "/" +
          //           item.dia.toString().substring(7, 5) +
          //           "/" +
          //           item.dia.toString().substring(0, 4)
          //       ),
          //       stripZeros(String(item.quantidadeProposta)),
          //       item.justificativa
          //     );
          //   })}
          //   // onClick={() => { console.log("You click the link"); }}
          //   enclosingCharacter={``}
          //   separator={";"}
          // >
          <Tooltip
            title={t("pages.dailyProductionRelease.text.downloadCsvFile")}
          >
            <span>
              <IconButton
                onClick={handleClickOpenDownloadCSV}
                disabled={loading || user.isSuporte}
              >
                <Download />
              </IconButton>
            </span>
          </Tooltip>
        ) : // </CSVLink>
        null}{" "}
      </div>
      <div className={`divFlow ${styles.table}`}>
        <div className={styles.table}>
          <DataGrid
            loading={loading}
            rows={rows}
            columns={columns}
            rowsPerPageOptions={[50, 100, 250, 500]}
            onSelectionModelChange={(ids) => {
              handleSelectionChange(ids);
            }}
            onCellEditCommit={handleRowEditCommit}
            onCellEditStart={handleCellEdtStart}
            checkboxSelection={(user.isRoot || user.isPlanejamento) && step < 3}
            disableSelectionOnClick
          />
        </div>
      </div>
      {user.isRoot && (
        <div className="divFlow">
          <LancamentoDiarioPassoAPasso {...{ data: step }} />
        </div>
      )}
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {t("pages.dailyProductionRelease.text.excelImport")}
            <br />
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <br />
              {FileUploadPage()}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              color="success"
              onClick={handleClose}
              autoFocus
            >
              {t("common.close")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <div>
        <Dialog
          open={openFilter}
          onClose={handleCloseFilter}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          id="filter"
        >
          <DialogTitle id="alert-dialog-title">
            {t("common.filter")}
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2} mt={2}>
              <Grid item xs={12}>
                <AutocompleteSKU
                  multiple
                  onChangeCallback={(e, newValue) => {
                    handleChangeFilter({
                      target: { name: FILTER_NAMES.codigoSku, value: newValue },
                    });
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  adapterlocale={ptBR}
                >
                  <DatePicker
                    inputFormat="dd/MM/yyyy"
                    label="Data Inicial"
                    value={filter[FILTER_NAMES.valueDTinicio]}
                    onChange={(newValue: any) => {
                      if (newValue) {
                        newValue.setHours(0);
                        newValue.setMinutes(0);
                        newValue.setSeconds(0);
                        newValue.setMilliseconds(0);
                      }
                      handleChangeFilter({
                        target: {
                          name: FILTER_NAMES.valueDTinicio,
                          value: newValue,
                        },
                      });
                    }}
                    renderInput={(params: any) => (
                      <TextField
                        {...params}
                        {...(!!filter[FILTER_NAMES.valueDTinicio] && {
                          value:
                            filter[
                              FILTER_NAMES.valueDTinicio
                            ]?.toLocaleDateString("pt-BR"),
                          InputLabelProps: { shrink: true },
                        })}
                        inputProps={{ placeholder: "01/04/2022" }}
                      />
                    )}
                    className={styles["datepicker-full"]}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={6}>
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  adapterlocale={ptBR}
                >
                  <DatePicker
                    inputFormat="dd/MM/yyyy"
                    label={t("common.finalDate")}
                    value={filter[FILTER_NAMES.valueDTfim]}
                    onChange={(newValue: any) => {
                      if (newValue) {
                        newValue.setHours(23);
                        newValue.setMinutes(59);
                        newValue.setSeconds(59);
                        newValue.setMilliseconds(999);
                      }
                      handleChangeFilter({
                        target: {
                          name: FILTER_NAMES.valueDTfim,
                          value: newValue,
                        },
                      });
                    }}
                    renderInput={(params: any) => (
                      <TextField
                        {...params}
                        {...(!!filter[FILTER_NAMES.valueDTfim] && {
                          value:
                            filter[FILTER_NAMES.valueDTfim]?.toLocaleDateString(
                              "pt-BR"
                            ),
                          InputLabelProps: { shrink: true },
                        })}
                        inputProps={{ placeholder: "01/04/2022" }}
                      />
                    )}
                    className={styles["datepicker-full"]}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id={"DesSku"}
                  value={filter[FILTER_NAMES.descricaoSku]}
                  name={FILTER_NAMES.descricaoSku}
                  label={t("common.skuDescription.label")}
                  placeholder={t("common.skuDescription.label")}
                  variant="outlined"
                  fullWidth
                  onChange={handleChangeFilter}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  value={filter[FILTER_NAMES.quantidade]}
                  id={"Quantidade"}
                  name={FILTER_NAMES.quantidade}
                  label={t("common.quantity")}
                  placeholder={t("common.quantity")}
                  variant="outlined"
                  fullWidth
                  onChange={handleChangeFilter}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Grid justifyContent="space-between" container padding={2}>
              <Grid item>
                <Button
                  variant="outlined"
                  color="inherit"
                  onClick={handleCloseFilter}
                  autoFocus
                  className={"button-close-dialog"}
                >
                  {t("common.close")}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  color="success"
                  onClick={handleFilter}
                  autoFocus
                >
                  {t("common.filter")}
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
      </div>
      <Snackbar
        open={openSnackBar}
        autoHideDuration={6000}
        onClose={handleCloseSnackBar}
      >
        <Alert
          onClose={handleCloseSnackBar}
          severity={csvFoiEnviado.isSuccess ? "success" : "error"}
          sx={{ width: "100%" }}
          action={
            <Button
              color="primary"
              size="small"
              onClick={handleClickOpenCSVDetalhesModal}
            >
              Ver detalhes
            </Button>
          }
        >
          {csvFoiEnviado.isSuccess
            ? t("common.csvWithSuccess")
            : t("common.csvWithError")}
        </Alert>
      </Snackbar>

      <Modal
        open={openDownloadCSVModal}
        onClose={handleCloseDownloadCSVModal}
        sx={{
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
        }}
      >
        <DownloadCSVModal
          handleClose={handleCloseDownloadCSVModal}
          rows={JSON.parse(JSON.stringify(rows)).map((item: any) => {
            item.quantidade = (item.quantidade + "").replace(".", ",");
            item.quantidadeProduzida = (item.quantidadeProposta + "").replace(
              ".",
              ","
            );
            item.quando = new Date(item.quando);
            item.aderencia = (item.aderencia + "").replace(".", ",");
            return item;
          })}
          columns={JSON.parse(
            JSON.stringify(
              columns.filter((x) => x.field != "siglaSku" && x.field != "hist")
            )
          ).map((item: any) => {
            item.field =
              item.field == "quantidadeProposta"
                ? "quantidadeProduzida"
                : item.field;
            return item;
          })}
          name={"Lançamento Diário"}
        />
      </Modal>

      <Modal
        open={openCSVDetalhesModal}
        onClose={handleCloseCSVDetalhesModal}
        sx={{
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
        }}
      >
        <CSVDetalhesModal
          handleClose={handleCloseCSVDetalhesModal}
          name={`${t("pages.dailyForecast.titlePage")} Step ${step}`}
          detalhes={csvFoiEnviado.details}
        />
      </Modal>

      {historyId > 0 && (
        <StepLogsHistoryDetalhe
          id={historyId}
          type={"LancamentoProducao"}
          onClose={() => setHistoryId(0)}
        />
      )}
    </div>
  );
}
